
const digest = 'd4b1597b5543ee39117c553e09b16621b5172c9e996aec3d720e45c53d1df013';
const css = `:root {
  --checkbox-margin-right: var(--spacer-1);
  --checklist-text-margin-bottom: var(--spacer-05);
}

.aha-editor-v2 .aha-editor-v2__body {
  ul {
    list-style-type: disc;
    > li > ul {
      list-style-type: circle;
      > li > ul {
        list-style-type: square;
        > li > ul {
          list-style-type: disc;
        }
      }
    }
  }

  ol {
    > li > ol {
      list-style-type: lower-alpha;
      > li > ol {
        list-style-type: lower-roman;
        > li > ol {
          list-style-type: decimal;
        }
      }
    }
  }

  ul,
  ol {
    margin: 0 0 var(--default-type-margin) calc(var(--default-type-margin) * 2);
    padding: 0;

    ul,
    ol {
      margin-bottom: 0;
    }
  }

  ._liCheckbox_1rtcb_43 {
    margin-right: var(--checkbox-margin-right);
    list-style-type: none;
    position: relative;

    ._checkboxContainer_1rtcb_48 {
      position: absolute;
      left: -1.3rem;
      top: 0.025em;
      font-size: calc(
        var(--aha-editor--user-font-size, 13px) *
          pow(
            var(--aha-editor--heading-ratio, 1.1),
            var(--aha-editor--heading-size, 1)
          )
      );
    }

    input[type='checkbox'] {
      margin: 0;
    }

    > p {
      margin-bottom: var(--checklist-text-margin-bottom);
    }

    /* Set checkbox line height based on first child type */
    &.h1-child {
      --aha-editor--heading-size: 6;
    }

    &.h2-child {
      --aha-editor--heading-size: 5;
    }

    &.h3-child {
      --aha-editor--heading-size: 4;
    }

    &.h4-child {
      --aha-editor--heading-size: 3;
    }

    &.h5-child {
      --aha-editor--heading-size: 2;
    }

    &.h6-child {
      --aha-editor--heading-size: 1;
    }
  }
}

._ulChecklist_1rtcb_96 {
  list-style: none;
}

._liCheckbox_1rtcb_43.paragraph-child,
._liCheckbox_1rtcb_43.fontSize-child {
  ._checkboxContainer_1rtcb_48 {
    transform: translateY(calc(5.5px - 0.3em));
  }
}

._hideMarker_1rtcb_107 {
  list-style-type: none;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"liCheckbox":"_liCheckbox_1rtcb_43","checkboxContainer":"_checkboxContainer_1rtcb_48","ulChecklist":"_ulChecklist_1rtcb_96","hideMarker":"_hideMarker_1rtcb_107"};
export { css, digest };
  